module.exports = __webpack_public_path__ + "img/javascript_icon.3059affd.png";